import { HttpError } from '@/lib/api/error';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/** Redirects to the 404 page when a query failed with an HTTP 404. */
export function use404Redirect(error: unknown) {
  const navigate = useNavigate();

  useEffect(() => {
    if (error instanceof HttpError && error.status === 404) {
      navigate('/404', { replace: true });
    }
  }, [error, navigate]);
}
